"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSafeUrl = void 0;
/**
 * Utility function which wraps javascript URL object. It preserves entire url (including pathname) of origin¨
 */
const getSafeUrl = (path, origin) => {
  if (!origin) {
    return path;
  }
  const originUrl = new URL(origin.endsWith('/') ? origin : `${origin}/`);

  // Get pathname from origin as prefix and get path without leading slash
  const newPathname = `${originUrl.pathname}${path.slice(1)}`;
  const {
    href
  } = new URL(newPathname, originUrl.origin);
  return href;
};
exports.getSafeUrl = getSafeUrl;
